import React from 'react';
import SearchBarComponent from './SearchBarComponent';
import NewProjectButton from './NewProjectButton';

// This component  renders the row above project's table and contains the search bar and the create new project button
const SearchBarRow = ({ searched, setSearched, isHome}) => (
    <div
        style={{
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '1rem',
        marginBottom: '1rem'
        }}
    >
        <SearchBarComponent searched={searched} setSearched={setSearched}/>   
        {isHome === true && (
            <div style={{display: 'flex', flexDirection: 'row'}}>
                <NewProjectButton/>
            </div>
        )}
    </div>
);

export default SearchBarRow